module.exports = function (angularModule) {
  angularModule.controller('reviewGenCtrl', function ($scope, $state, accountSettingsModal, contactDownloadModal, reviewGenService, $window) {
    $scope.openAccountSettingsModal = () => {
      accountSettingsModal.open();
    }

    $scope.openContactsDownloadModal = () => {
      contactDownloadModal.open();
    }
  });
};
